import { useTheme as useMuiTheme } from '@mui/material/styles';
import { layoutTokens } from './layout-tokens';

/**
 * Test-safe wrapper around MUI's useTheme that injects finance layout
 * tokens when the component is rendered outside of a FinanceThemeProvider.
 */
export function useTheme() {
  const theme = useMuiTheme();
  return {
    ...theme,
    financeLayout: (theme as { financeLayout?: typeof layoutTokens }).financeLayout ?? layoutTokens,
  };
}
